import React from "react";

const ChiliPiperIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3054 5.58601C14.1348 5.6841 16.0082 6.04085 16.8659 6.68308L17.0367 6.39836C16.8299 6.20739 16.3599 5.7796 16.1343 5.59618C16.4383 4.96953 16.8893 3.3162 16.2614 1.71607L15.6363 2.4557C15.6341 3.10245 15.4704 4.55517 14.8345 5.19204L13.4766 5.18716L13.3054 5.58601Z",
  fill: "#0067E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.48719 15.2036C5.01092 16.6497 3.50848 17.6994 2.45325 18.2757C4.99023 18.3644 7.21217 17.8408 9.12256 16.9671C8.1779 16.4776 7.29456 15.8848 6.48719 15.2036Z",
  fill: "#F8C030"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4221 16.2941C9.29354 15.7891 8.24224 15.1406 7.29089 14.3717C8.21854 13.3562 9.10018 12.1844 9.81203 10.8764C10.1111 11.0725 10.418 11.2577 10.7322 11.4312C9.99296 12.8345 9.1914 13.9759 8.69022 14.586C9.68729 13.9721 10.5863 12.9077 11.338 11.7472C12.3519 12.2452 13.4331 12.6255 14.5644 12.8705C13.4545 14.1212 12.0747 15.3342 10.4221 16.2941Z",
  fill: "#F8C030"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4688 7.35566C13.1901 8.18021 12.661 9.45723 11.9437 10.7397C13.0182 11.2637 14.168 11.6558 15.3725 11.8949C16.4361 10.5183 17.1761 9.16367 17.5963 8.1151C15.8824 6.41976 12.7379 6.06225 11.3799 6.09542C11.2216 7.42094 10.8489 8.66654 10.3345 9.82031C10.6319 10.0171 10.9371 10.2029 11.2495 10.3772C11.7223 9.33731 12.1244 8.20456 12.3382 7.06626C12.5834 7.06714 13.1528 7.12626 13.4688 7.35566Z",
  fill: "#0067E3"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_375"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6667,
  height: 16.6667,
  fill: "white",
  transform: "translate(1.66663 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChiliPiperIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;